/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Standardmembershipfee2Inputs */

const de__field_standardmembershipfee2 = /** @type {(inputs: _Field_Standardmembershipfee2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standard Mitgliedschaftsbeitrag in €`)
};

/**

* @param {_Field_Standardmembershipfee2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_standardmembershipfee2 = /** @type {((inputs?: _Field_Standardmembershipfee2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Standardmembershipfee2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_standardmembershipfee2(inputs)
});
export { _field_standardmembershipfee2 as "_field_standardMembershipFee" }